export const listDeploymentAccountGroups = `
   query listDeploymentAccountGroups {
       listDeploymentAccountGroups {
           items {
              id
              name
              accounts {
                accountId
                accountName
                region
                environment
              }
           }
       }
   }
`;

export const getDeploymentAccountGroup = `
   query getDeploymentAccountGroup($id:ID!) {
       getDeploymentAccountGroup(id:$id) {
         id
         name
         accounts {
           accountId
           accountName
           region
           environment
         }
       }
}`;
